// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: "",
  tokenWeb: "",
  usernameWeb: "",
  userTypeWeb: "",
  refreshTokenWeb: "",
  tokenExpDateWeb: "",
  refreshTokenExpDateWeb: "",
  user: {},
  tableList: [],
  userList: [],
  userListCount: null,
  headerLinks: [],
  drawer: true,
  showSnackbar: false,
  snackbarMsg: "",
  showDialog: false,
  dialogMsg: "",
  snackbarColor: "",
  profile: {},
  vaInfo: {},
  titleApp: "Meakappin",
  banks: {},
  features: {},
  showRegVaDialog: false,
  showPopUpNotificationDialog: false,
  justLoggedIn: false,
  bankAccInfo: {},
  vaProfile: {},
  productPartners: {},
  products: {},
  latest403Page: "",
  cart: {},
  currItemId: "",
  initCurrProduct: {},
  initViewCurrProduct: {},
  checkoutItems: {},
  isLoading: false,
  transactions: {},
  transactionsNew: {},
  // faq:{},
  cartList: {
    new: {},
    draft: {},
  },
  cartListReward: [],
  totaoToBePaidInPayment: '',
  // faqById: [],
  // faqList: {
  //   FC_CLAIM: {},
  //   FC_E_POLICY: {},
  //   FC_GENERAL: {},
  // },
  salesReport: {},
  vaHistory: {},
  viewOrderdetails: {},
  productPaymentTypeList: [],
  productDetails: null,
  customerTypeList: [],
  customerList: {},
  viewCartdetails: {},
  sertifikatList: {},
  sertifikatInfo: {},
  initCurrProductRecurr: {},
  certSearchKeyList: [],
  checkoutSum: 0,
  viewOrderSum: 0,
  countNotifUnread: 0,

  viewModeReqCert: [],
  programInfoInquiry: [],
  programNotif: [],
  readProgramNotif: [],

  popupNotif: [],
  popupNotifById: [],
  popupReadNotif: [],

  faqCategoryList: [],
  inquiryFaq: [],
  inquiryFaqWithoutContent: [],

  programInfoById: {},

  inquirySalesKit: [],
  salesKitById: {},
  listSalesKitItem: [],
  kecamatanList: [],
  userTypeListWeb: [],
  checkboxItemDetail: [],
  checkboxItemsChosenQty: [],
  checkboxItemsChosen: [],
  checkboxItemsChosenReward: [],
  checkboxItemsChosenQtyReward: [],
  checkboxItemsChosenDetail: [],
  checkboxItemsChosenDetailPromo: [],
  promoList: [],
  promoTotal: 0,
  totalToBePaid: 0,
  promoChosen: "",
  promoSum: 0,
  totalToBePaidSum: 0,
  viewOrderItems: [],
  promoChosenCode: "",
  promoChosenName: "",
  programCode: null,
  errorMessage: "",
  namaProdukState: "",
  changeOldPassFlag: "",
  acceptTermCondFlag: "",
  formRequestDealerCash: "",
  internalCartId: "",
  premiumResponse: "",
  dataInitAdd: "",
  paymentTotal: "",
  distTypeList: [],
  distType: "",
};
